import Header from './Header';

const Levels = () => <Header label="Levels" />;

export default Levels;
